var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.parentInfo.catCd !== "V"
    ? _c(
        "GmapMap",
        {
          ref: "gmap",
          staticStyle: { width: "100%", height: "100%" },
          attrs: {
            zoom: _vm.zoom,
            center: _vm.center,
            options: _vm.mapOptions,
            "map-type-id": "roadmap",
          },
        },
        [
          _vm.markerIcon
            ? _c("GmapMarker", {
                attrs: {
                  position: _vm.makerLatLng,
                  icon: _vm.markerIcon,
                  options: { optimized: false },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm.parentInfo.catCd === "V"
    ? _c("div", { style: _vm.mapStyle, attrs: { id: "map" } })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }